import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { theme } from 'utils/style/theme';
import { bubbleSetApi } from 'apis/platform/bubbleSetApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import RegisterButton from 'components/button/RegisterButton';
import MainTable from 'components/table/MainTable';
import CapsuleButton from 'components/button/CapsuleButton';
import BubbleSetRegisterModal from './BubbleSetRegisterModal';
import BubbleUpdateModal from './BubbleUpdateModal';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import TextButton from 'components/button/TextButton';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 세트 목록
 */

const BubbleMainListPage = () => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const { platformAuth = 'false' } = cookies;
  const navigate = useNavigate();
  const [visible, setVisible] = useState({
    register: false,
    update: false,
  });
  const [searchData, setSearchData] = useState();
  const [datas, setDatas] = useState();
  const [updateData, setUpdateData] = useState(); //updateModal에 실을 데이터

  const handleVisible = (record) => (e) => {
    const { name } = e.target;
    setVisible({ ...visible, [name]: true });
    if (record) {
      setUpdateData(record);
    }
  };

  const handleDetail = (record) => () => {
    navigate(`/bubble/${record.set_id}/normal`, {
      state: {
        record: record,
      },
    });
  };

  const handleDelete = (record) => async () => {
    const res = await bubbleSetApi.delete(record.set_id);
    if (res !== false) {
      fetchData();
      message.success('말풍선이 삭제되었습니다.');
    }
  };

  /// 데이터 불러오기
  const fetchData = async () => {
    const response = await bubbleSetApi.read();
    setDatas(response);
  };

  const columnsOrigin = [
    {
      title: 'ID',
      dataIndex: 'set_id',
      width: '4rem',
    },
    {
      title: t('bubble.table.balloonName'),
      dataIndex: 'set_name',
      key: 'set_name',
      width: '15rem',
      render: (text, record) => (
        <TextButton onClick={handleDetail(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('bubble.table.memo'),
      dataIndex: 'remark',
      width: '15rem',
    },
    {
      title: t('bubble.table.fontSize'),
      children: [
        {
          title: t('bubble.table.regularFont'),
          dataIndex: 'normal_font_size',
          width: '5rem',
          align: 'center',
        },
        {
          title: t('bubble.table.largeFont'),
          dataIndex: 'big_font_size',
          width: '5rem',
          align: 'center',
        },
      ],
    },
    {
      title: t('bubble.table.lineSpacing'),
      dataIndex: 'line_space',
      width: '5rem',
      align: 'center',
    },
    {
      title: t('bubble.table.nameTagSetting'),
      children: [
        {
          title: t('bubble.table.leftMargin'),
          dataIndex: 'tag_textarea_left',
          width: '5rem',
          align: 'center',
        },
        {
          title: t('bubble.table.rightMargin'),
          dataIndex: 'tag_textarea_right',
          width: '5rem',
          align: 'center',
        },
        {
          title: t('bubble.table.topMargin'),
          dataIndex: 'tag_textarea_top',
          width: '5rem',
          align: 'center',
        },
        {
          title: t('bubble.table.bottomMargin'),
          dataIndex: 'tag_textarea_bottom',
          width: '5rem',
          align: 'center',
        },
      ],
    },
    {
      title: t('bubble.table.action'),
      align: 'center',
      width: '10rem',
      render: (text, record) => (
        <div>
          <CapsuleButton
            name='update'
            onClick={handleVisible(record)}
            disabled={JSON.parse(platformAuth)}
            style={{ marginRight: `${theme.margins.marginRight}` }}
          >
            {t('bubble.table.edit')}
          </CapsuleButton>
          <DeletePopConfirm
            title={t('bubble.table.deleteMessage')}
            onConfirm={handleDelete(record)}
            disabled={JSON.parse(platformAuth)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <SearchInput
            placeholder={t('bubble.header.searchByBalloonName')}
            setSearchData={setSearchData}
          />
          <RegisterButton
            name='register'
            onClick={handleVisible(null)}
            disabled={JSON.parse(platformAuth)}
          >
            {t('bubble.header.addBalloonSet')}
          </RegisterButton>
        </TableToolbar>
        <MainTable
          columns={columnsOrigin}
          dataSource={
            searchData
              ? datas.filter((data) => data.set_name.indexOf(searchData) !== -1)
              : datas
          }
        />
      </DefaultLayout>
      {/* 모달 모음 */}
      <BubbleSetRegisterModal
        visible={visible.register}
        setVisible={setVisible}
        fetchData={fetchData}
      />
      <BubbleUpdateModal
        visible={visible.update}
        setVisible={setVisible}
        record={updateData}
        fetchData={fetchData}
      />
    </>
  );
};

export default BubbleMainListPage;
